"use client";

import { LayoutGrid, Rows3 } from "lucide-react";
import { useDict } from "@/components/i18n/DictProvider";
import { cn } from "@/components/ui/cn";

export type ViewMode = "grid" | "list";

export function ViewToggle({
  value,
  onChange,
  className,
}: {
  value: ViewMode;
  onChange: (v: ViewMode) => void;
  className?: string;
}) {
  const t = useDict();
  const labelGrid = t.listing.gridShort;
  const labelList = t.listing.listShort;
  return (
    <div
      role="group"
      aria-label={t.listing.viewLabel}
      className={cn(
        "inline-flex items-center gap-0.5 p-1 rounded-full bg-foreground/[0.05] border border-border/60",
        className,
      )}
    >
      <Btn
        active={value === "list"}
        onClick={() => onChange("list")}
        label={labelList}
        Icon={Rows3}
      />
      <Btn
        active={value === "grid"}
        onClick={() => onChange("grid")}
        label={labelGrid}
        Icon={LayoutGrid}
      />
    </div>
  );
}

function Btn({
  active,
  onClick,
  label,
  Icon,
}: {
  active: boolean;
  onClick: () => void;
  label: string;
  Icon: typeof LayoutGrid;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      aria-label={label}
      title={label}
      className={cn(
        "inline-flex items-center justify-center gap-1.5 min-h-[40px] min-w-[44px] pointer-coarse:min-h-11 px-3 rounded-full text-[11px] uppercase tracking-[0.12em] font-bold transition-colors",
        active
          ? "bg-accent text-accent-foreground shadow-[0_1px_2px_rgb(0_0_0/0.06),inset_0_1px_0_hsl(40_80%_92%/0.6)]"
          : "text-foreground/65 hover:text-foreground",
      )}
    >
      <Icon className="size-4" aria-hidden strokeWidth={2.25} />
      <span className="hidden sm:inline">{label}</span>
    </button>
  );
}
